import {ContentResultUrlDomain} from "../../domain/content/ContentResultUrlDomain"

/**
 * 콘텐츠 참여 결과 URL 속성 설명
 */
export const ContentResultUrlDescription: Record<keyof ContentResultUrlDomain, string> = {
    id: '기본키',
    creatorId: '생성자 ID',
    browser: '브라우저',
    url: '참여 결과 URL',
    clickCount: '클릭 수',
    createdAt: '생성일',
    lastModifiedAt: '마지막 수정일',
    concealedAt: '삭제일'
}
